<p-toast></p-toast>
<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>All Components</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">                          
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" class="p-button-success p-mr-2"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <table class="normal-table">
                            <tr>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <input type="text"  pInputText disabled="false"> 
                                        <label for="inputtext">InputText <span class="hlt-txt">*</span></label>
                                    </span>
                                    <small class="p-invalid">Username is not available.</small>
                                </td>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <p-autoComplete inputId="autocomplete1" field="name" disabled=""></p-autoComplete>
                                        <label for="autocomplete">AutoComplete</label>
                                    </span>
                                </td>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <p-calendar dateFormat="dd/mm/yy" [showIcon]="true" disabled=""></p-calendar>
                                        <label for="inputtext">Calendar</label>
                                    </span>
                                </td>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <p-chips></p-chips>
                                        <label for="chips">Chips</label>
                                    </span>
                                </td>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <p-inputMask mask="99/99/9999"></p-inputMask>
                                        <label for="inputmask">InputMask</label>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="p-float-label">
                                        <p-inputNumber></p-inputNumber>
                                        <label for="inputnumber">InputNumber</label>
                                    </span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <div class="browse-links">
                                                <p-button label="Link" styleClass="p-button-link" (click)="showBasicDialog('bottom-right')"></p-button>
                                            </div>
                                        </span>
                                        <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only" pTooltip="Browse File" tooltipPosition="top" mode="basic" name="demo[]" accept="image/*" maxFileSize="1000000" chooseLabel="" #fileUpload (onSelect)="fileChangeEvent($event)"></p-fileUpload>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Cancel" tooltipPosition="top">
                                            <i class="las la-times"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <span class="p-float-label">
                                        <p-dropdown [autoDisplayFirst]="false" optionLabel="name"></p-dropdown>
                                        <label for="dropdown">Dropdown</label>
                                    </span>
                                </td>
                                <td>
                                    <span class="p-float-label">
                                        <p-multiSelect optionLabel="name"></p-multiSelect>
                                        <label for="multiselect">MultiSelect</label>
                                    </span>
                                </td>
                                <td rowspan="2">
                                    <span class="p-float-label">
                                        <textarea inputId="textarea" rows="2" cols="30" pInputTextarea></textarea>
                                        <label for="textarea">Textarea</label>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p-inputSwitch [(ngModel)]="checked1"></p-inputSwitch> Widget 01
                                </td>
                                <td>
                                    <div class="p-formgroup-inline">
                                        <h6>Inline Style Checkbox</h6>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group1" value="New York" [(ngModel)]="selectedCities" inputId="ny"></p-checkbox>
                                            <label for="ny">New York</label>
                                        </div>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group2" value="Columbia" [(ngModel)]="selectedCities" inputId="cl"></p-checkbox>
                                            <label for="cl">Columbia</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-formgroup">
                                        <h6>Block Style Checkbox</h6>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group3" value="New York 1" [(ngModel)]="selectedCities" inputId="ny1"></p-checkbox>
                                            <label for="ny1">New York</label>
                                        </div>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group4" value="Columbia 1" [(ngModel)]="selectedCities" inputId="cl1"></p-checkbox>
                                            <label for="cl1">Columbia</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <input type="text"  pInputText> 
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Search" tooltipPosition="top">
                                            <i class="las la-search"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="p-formgroup-inline">
                                        <h6>Inline Style Radio Button</h6>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Chicago1" [(ngModel)]="city" inputId="city11"></p-radioButton>
                                            <label for="city11">Chicago</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Los Angeles1" [(ngModel)]="city" inputId="city21"></p-radioButton>
                                            <label for="city21">Los Angeles</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="New York1" [(ngModel)]="city" inputId="city31"></p-radioButton>
                                            <label for="city31">New York</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-formgroup">
                                        <h6>Block Style Radio Button</h6>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Chicago" [(ngModel)]="city" inputId="city1"></p-radioButton>
                                            <label for="city1">Chicago</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Los Angeles" [(ngModel)]="city" inputId="city2"></p-radioButton>
                                            <label for="city2">Los Angeles</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="New York" [(ngModel)]="city" inputId="city3"></p-radioButton>
                                            <label for="city3">New York</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <input type="text"  pInputText> 
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Dialog Box" (click)="showBasicDialog1()" tooltipPosition="top">
                                            <i class="las la-external-link-alt"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <p-dropdown [autoDisplayFirst]="false" optionLabel="name"></p-dropdown>
                                            <label for="dropdown">Dropdown</label>
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Add" tooltipPosition="top">
                                            <i class="las la-plus"></i>
                                        </button>
                                    </div>
                                </td>
                                <td colspan="2">
                                    <p-button label="Submit" icon="las la-check"></p-button>
                                    <p-button label="Print" icon="las la-print"></p-button>
                                    <p-button label="Send Email" icon="las la-envelope"></p-button>
                                    <p-button label="Email Sent" icon="las la-paper-plane"></p-button>
                                </td>
                            </tr>
                        </table>
                        <table class="normal-table">
                            <tr>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <input type="password"  value="" pPassword showPassword="true" feedback="false"> 
                                        <label for="inputtext">InputText <span class="hlt-txt">*</span></label>
                                    </span>
                                </td>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <p-autoComplete inputId="autocomplete2" field="name" class="default-load"></p-autoComplete>
                                        <label for="autocomplete">AutoComplete</label>
                                    </span>
                                </td>
                                <td style="width:40%" colspan="2">
                                    <table class="normal-table">
                                        <tr>
                                            <td style="width:50%">
                                                <span class="p-float-label">
                                                    <p-calendar dateFormat="dd/mm/yy" [ngModel]="defaultDate" [showIcon]="true" class="default-load"></p-calendar>
                                                    <label for="inputtext">Calendar</label>
                                                </span>
                                            </td>
                                            <td style="width:50%">
                                                <span class="p-float-label">
                                                    <p-chips [disabled]="disabled"></p-chips>
                                                    <label for="chips">Chips</label>
                                                </span>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                                <td style="width:20%">
                                    <span class="p-float-label">
                                        <p-inputMask mask="99/99/9999" class="default-load"></p-inputMask>
                                        <label for="inputmask">InputMask</label>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span class="p-float-label">
                                        <p-inputNumber class="default-load"></p-inputNumber>
                                        <label for="inputnumber">InputNumber</label>
                                    </span>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <div class="browse-links">
                                                <p-button label="Link" styleClass="p-button-link" (click)="showBasicDialog('bottom-right')"></p-button>
                                            </div>
                                        </span>
                                        <p-fileUpload class="p-inputgroup-addon p-button p-button-icon-only" pTooltip="Browse File" tooltipPosition="top" mode="basic" name="demo[]" accept="image/*" maxFileSize="1000000" chooseLabel=""></p-fileUpload>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Cancel" (click)="RemoveFile()" tooltipPosition="top">
                                            <i class="las la-times"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <span class="p-float-label">
                                        <p-dropdown [autoDisplayFirst]="false" optionLabel="name" class="default-load"></p-dropdown>
                                        <label for="dropdown">Dropdown</label>
                                    </span>
                                </td>
                                <td>
                                    <span class="p-float-label">
                                        <p-multiSelect optionLabel="name" [disabled]="disabled"></p-multiSelect>
                                        <label for="multiselect">MultiSelect</label>
                                    </span>
                                </td>
                                <td rowspan="2">
                                    <span class="p-float-label">
                                        <textarea inputId="textarea" rows="2" cols="30" pInputTextarea></textarea>
                                        <label for="textarea">Textarea</label>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p-inputSwitch [(ngModel)]="checked1" [disabled]="disabled"></p-inputSwitch> Widget 01
                                </td>
                                <td>
                                    <div class="p-formgroup-inline">
                                        <h6>Inline Style Checkbox</h6>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group1" value="New York" [(ngModel)]="selectedCities" inputId="ny11" [disabled]="disabled"></p-checkbox>
                                            <label for="ny11">New York</label>
                                        </div>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group2" value="Columbia" [(ngModel)]="selectedCities" inputId="cl1" [disabled]="disabled"></p-checkbox>
                                            <label for="cl1">Columbia</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-formgroup">
                                        <h6>Block Style Checkbox</h6>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group3" value="New York 1" [(ngModel)]="selectedCities" inputId="ny1"></p-checkbox>
                                            <label for="ny1">New York</label>
                                        </div>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group4" value="Columbia 1" [(ngModel)]="selectedCities" inputId="cl1"></p-checkbox>
                                            <label for="cl1">Columbia</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <input type="text"  pInputText> 
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Search" tooltipPosition="top">
                                            <i class="las la-search"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="p-formgroup-inline">
                                        <h6>Inline Style Radio Button</h6>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Chicago1" [(ngModel)]="city" inputId="city11"></p-radioButton>
                                            <label for="city11">Chicago</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Los Angeles1" [(ngModel)]="city" inputId="city21"></p-radioButton>
                                            <label for="city21">Los Angeles</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="New York1" [(ngModel)]="city" inputId="city31"></p-radioButton>
                                            <label for="city31">New York</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-formgroup">
                                        <h6>Block Style Radio Button</h6>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Chicago" [(ngModel)]="city" inputId="city1"></p-radioButton>
                                            <label for="city1">Chicago</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="Los Angeles" [(ngModel)]="city" inputId="city2"></p-radioButton>
                                            <label for="city2">Los Angeles</label>
                                        </div>
                                        <div class="p-field-radiobutton">
                                            <p-radioButton name="city" value="New York" [(ngModel)]="city" inputId="city3"></p-radioButton>
                                            <label for="city3">New York</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <input type="text"  pInputText> 
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Dialog Box" (click)="showBasicDialog1()" tooltipPosition="top">
                                            <i class="las la-external-link-alt"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <p-dropdown [autoDisplayFirst]="false" optionLabel="name"></p-dropdown>
                                            <label for="dropdown">Dropdown</label>
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Add" tooltipPosition="top">
                                            <i class="las la-plus"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <p-autoComplete inputId="autocomplete3" field="name"></p-autoComplete>
                                            <label for="autocomplete">AutoComplete</label>
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Add" tooltipPosition="top">
                                            <i class="las la-plus"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="p-inputgroup">
                                        <span class="p-float-label">
                                            <p-multiSelect optionLabel="name"></p-multiSelect>
                                            <label for="multiselect">MultiSelect</label>
                                        </span>
                                        <button class="p-inputgroup-addon p-button" pTooltip="Add" tooltipPosition="top">
                                            <i class="las la-plus"></i>
                                        </button>
                                    </div>
                                </td>
                                <td>
                                    <div class="p-field-inline">
                                    <div class="p-field-control">
                                        <span class="p-float-label">
                                        <input type="text" pInputText />
                                        <label for="remarks">Percentage</label>
                                        </span>
                                    </div>
                                    <div class="p-field-control">
                                        <span class="p-float-label">
                                        <input type="text" pInputText />
                                        <label for="remarks">Product Code</label>
                                        </span>
                                    </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                        <div class="sub-title">
                            <h5>Sub Title Comes Here</h5>
                        </div>
                        <table class="normal-table">
                            <tr>
                                <td style="width:20%">
                                    <div class="file-upload-wrapper" data-text="Select your file!">
                                        <input type="file" class="file-upload-field" (change)="fileChangeEvent($event)" value="">
                                        <!-- fileChangeEvent($event) -->
                                    </div>
                                </td>
                                <td>Zimbabwe Date : <strong>{{date}}</strong></td>
                                <td>Zimbabwe Time Zone : <strong>{{time}}</strong></td>
                                <td>Zimbabwe Time  in (Sec) : <strong>{{sec}}</strong></td>
                                <td>Zimbabwe Time  in (ms) : <strong>{{ms}}</strong></td>
                            </tr>
                        </table>
                        <div class="sub-title">
                            <h5>Prime-NG Paginator</h5>
                        </div>
                        <p-paginator [first]="first" [rows]="1" [totalRecords]="totalRecords" (onPageChange)="onPageChange($event)"
                        [showJumpToPageDropdown]="true" [showPageLinks]="false"></p-paginator>
                        <div class="text-center">
                            <img src="assets/images/products/{{first + 01}}.jpg" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<p-dialog header="Image Preview" [(visible)]="displayBasic" [position]="position" [style]="{width: '500px'}" [baseZIndex]="10000">
    <img src="../../assets/images/chart03.jpg" alt="" class="img-preview">
    <button class="p-inputgroup-addon p-button" title="Delete">
        <i class="pi pi-trash"></i>
    </button>
    <ng-template pTemplate="footer">
        <p-button icon="las la-check" (click)="displayBasic=false" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>
<p-dialog header="Long Content" [(visible)]="displayBasic1" [modal]="true" [style]="{width: '50vw',height: '500px'}" [baseZIndex]="10000">
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi
        ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
        culpa qui officia deserunt mollit anim id est laborum.</p>
    <ng-template pTemplate="footer">
        <p-button icon="las la-check" (click)="displayBasic1=false" label="Ok" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>
<p-dialog header="Image Cropper" [(visible)]="imageCropperTool" [modal]="true" [style]="{width: '1200px'}" [baseZIndex]="10000">
    <div class="text-center mb10">
        <button pButton pRipple label="" icon="las la-plus" pTooltip="Zoom +" tooltipPosition="top" (click)="zoomIn()" class="p-button p-mr-2"></button>
        <button pButton pRipple label="" icon="las la-minus" pTooltip="Zoom -" tooltipPosition="top" (click)="zoomOut()" class="p-button p-mr-2"></button>
        <button pButton pRipple label="" icon="las la-redo-alt" pTooltip="Reset Image" tooltipPosition="top" (click)="resetImage()" class="p-button-danger p-mr-2"></button>
        <button pButton pRipple label="" icon="las la-save" pTooltip="Save" tooltipPosition="top" (click)="onSave()" class="p-button-success p-mr-2"></button>
    </div>
    <div class="row">
        <div class="col-md-6">
            <h5>Input</h5>
            <div class="crop-input">
                <image-cropper class="img-fluid"
                    [imageChangedEvent]="imageChangedEvent"
                    [maintainAspectRatio]="true"
                    [containWithinAspectRatio]="containWithinAspectRatio"
                    [aspectRatio]="106 / 57"
                    [resizeToWidth]="530"
                    [cropperMinWidth]="128"
                    [onlyScaleDown]="true"
                    [roundCropper]="false"
                    [canvasRotation]="canvasRotation"
                    [transform]="transform"
                    [alignImage]="'left'"
                    [style.display]="showCropper ? null : 'none'"
                    format="png"
                    (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded()"
                    (cropperReady)="cropperReady($event)"
                    (loadImageFailed)="loadImageFailed()"
                ></image-cropper>
            </div>        
        </div>
        <div class="col-md-6">
            <h5>Output</h5>
            <img [src]="croppedImage" />
        </div>
    </div>
</p-dialog>